function pad(s) { return (s < 10) ? `0${s}` : s }

export function dateToDDMMYYYY(inputFormat) {
  const d = new Date(inputFormat)

  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
}


export function dateToTime(inputFormat) {
  if (!inputFormat) { return inputFormat }
  const d = new Date(inputFormat)

  return [pad(d.getHours()), pad(d.getMinutes())].join(':')
}

export function dateToDateTime(inputFormat) {
  if (!inputFormat) {
    return null
  }

  return `${dateToDDMMYYYY(inputFormat)} ${dateToTime(inputFormat)}`
}
